import { defineMessages } from "react-intl";

export const messages = defineMessages({
  empty: {
    id: "zv9OGI",
    defaultMessage: "No models found",
  },
  published: {
    id: "GhSB79",
    defaultMessage: "Published",
    description: "model status",
  },
  notPublished: {
    id: "3dJ2Sc",
    defaultMessage: "Not published",
    description: "model status",
  },
});

export const columnsMessages = defineMessages({
  title: {
    id: "0XHXTZ",
    defaultMessage: "Title",
    description: "column header",
  },
  slug: {
    id: "kIcyUo",
    defaultMessage: "Slug",
    description: "column header",
  },
  visible: {
    id: "wLB8B3",
    defaultMessage: "Visibility",
    description: "column header",
  },
  contentType: {
    id: "fuUksg",
    defaultMessage: "Model Type",
    description: "column header",
  },
});
